





























import { computed, defineComponent, PropType } from '@vue/composition-api';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { Community } from '@front-app/services/CommunityApi/CommunityModel';
import { deleteCommunity } from '@front-app/services/CommunityApi/CommunityApi';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { Routes } from '@front-app/constants/routes';

export default defineComponent({
	components: {
		SimpleCard,
		CtaButton,
	},
	props: {
		community: {
			type: Object as PropType<Community>,
			required: true,
		},
	},
	setup(props, ctx) {
		const {
			track: trackDelete,
			isLoading: isDeleting,
		} = useAsyncStatus();
		const deleteSelf = async () => {
			// eslint-disable-next-line no-alert
			const shouldContinue = window.confirm('This community will be permanently deleted.');
			if (shouldContinue) {
				await deleteCommunity(props.community.id);
				ctx.emit('deleted');
			}
		};
		const toCommunity = computed(() => ({
			name: Routes.MANAGE_COMMUNITY_EDIT_COMMUNITY,
			params: { communityId: props.community.id },
		}));
		return {
			trackDelete,
			isDeleting,
			deleteSelf,
			toCommunity,
		};
	},
});
